export default "__VITE_ASSET__de7d912f__"